import { bool, func } from 'prop-types';
import React, { Component } from 'react';
import { Col, FormGroup, Label } from 'reactstrap';

import SingleSelect from '../../generic/SingleSelect';
import { salesUnits, salesUnitSalesTeams } from '../../opportunities/constants';
import { agreementShape } from '../../prop-types';

export default class AgreementSalesUnit extends Component {
  handleSalesUnitChange = e => {
    const { onChange } = this.props;
    onChange(e);

    onChange({
      target: {
        name: 'salesTeam',
        value: '',
      },
    });
  };

  render() {
    const { agreement, onChange, readOnly } = this.props;
    const { salesUnit, salesTeam } = agreement;

    return (
      <>
        <FormGroup row>
          <Label sm={3} for="agr-salesUnit" className="required">
            Sales Unit
          </Label>
          <Col sm={9}>
            <SingleSelect
              options={salesUnits}
              id="agr-salesUnit"
              name="salesUnit"
              value={salesUnit}
              onChange={this.handleSalesUnitChange}
              readOnly={readOnly}
            />
          </Col>
        </FormGroup>
        {salesUnitSalesTeams[salesUnit]?.length > 0 && (
          <FormGroup row>
            <Label sm={3} for="agr-salesTeam" className="required">
              Sales Team
            </Label>
            <Col sm={9}>
              <SingleSelect
                options={salesUnitSalesTeams[salesUnit]}
                id="agr-salesTeam"
                name="salesTeam"
                value={salesTeam}
                onChange={onChange}
                readOnly={readOnly}
              />
            </Col>
          </FormGroup>
        )}
      </>
    );
  }
}

AgreementSalesUnit.propTypes = {
  agreement: agreementShape.isRequired,
  onChange: func,
  readOnly: bool,
};

AgreementSalesUnit.defaultProps = {
  onChange: () => {},
  readOnly: undefined,
};
